export class ApiError extends Error {
  response: Response

  constructor(res: Response, message?: string) {
    super(message)
    this.response = res
  }

  get status() {
    return this.response.status
  }
}
